import { useState } from 'react';
import { EyeOff, Mail } from 'lucide-react';
import { api, type Session } from '../api';
import { Button } from '../components/ui/button';

/** One email triage ignored, with the reason; mirrors GET /app-api/mail/ignored. */
export interface IgnoredMail { id:string; revision:number; from:string; subject:string; receivedAt:string; reason:string; excerpt:string }

/** The Inbox's Ignored filter: automated and non-AR email, never posted to Slack. An owner can process one anyway. */
export function IgnoredMailPanel({ session, items, onChanged }:{ session:Session; items:IgnoredMail[]; onChanged:()=>Promise<void> }) {
  const [selectedId, setSelectedId] = useState(''); const [busy, setBusy] = useState(false);
  const [error, setError] = useState(''); const [notice, setNotice] = useState('');
  const selected = items.find(item => item.id === selectedId) ?? items[0];
  const owner = session.actor.roles.includes('owner');
  async function processAnyway(item:IgnoredMail) {
    setBusy(true); setError(''); setNotice('');
    try {
      await api(`/app-api/mail/${item.id}/process`, { revision:item.revision });
      setNotice('Processing. The email now appears under Needs review.'); await onChanged();
    } catch (e) { setError(e instanceof Error ? e.message : 'Please try again.'); } finally { setBusy(false); }
  }
  return <>
    <div className="queue-items">{items.map(item => <button key={item.id}
      className={`queue-item ${item.id === selected?.id ? 'selected' : ''}`}
      aria-label={`Ignored email ${item.subject}`} onClick={() => setSelectedId(item.id)}>
      <div className="queue-item-top"><span className="customer-avatar"><Mail size={17}/></span>
        <div><strong>{item.from}</strong><span>{item.subject}</span></div></div>
      <div className="queue-item-bottom"><span className="stage-chip">Ignored</span><small>{item.reason}</small></div></button>)}</div>
    {!items.length && <div className="queue-empty"><EyeOff size={28}/><strong>No ignored email</strong>
      <p>Automated and non-AR email is kept here, out of Slack.</p></div>}
    {selected && <div className="classification-note" aria-label="Selected ignored email">
      {error && <div className="alert error" role="alert">{error}</div>}
      {notice && <div className="alert notice" role="status">{notice}</div>}
      <span className="eyebrow">IGNORED</span><p><strong>{selected.subject}</strong><br/>From {selected.from}</p>
      <p>Ignored: {selected.reason}</p>{selected.excerpt && <p className="muted">{selected.excerpt}</p>}
      {owner ? <Button variant="outline" disabled={busy} onClick={() => void processAnyway(selected)}>Process anyway</Button>
        : <p className="muted">An owner can process this email anyway.</p>}
    </div>}
  </>;
}
